module.exports = __webpack_public_path__ + "static/media/load3.de1de89d.gif";